import React, { useState } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { ICON_LIST } from '../../../../../lib/constants'
import actions from '../actions'
import AllIcons from './IconContent/IconList'
import ClearCircle from '../../../../../assets/svg/Feather/ClearCircle'
import FavoriteIcons from './IconContent/IconFavorites'
import Chip from '../../../../Chip'
import IconItem from './IconContent/IconItem'
import Search from '../../../../../assets/svg/Feather/Search'
import styles from './FeatureIconEditor.module.scss'
import typeIcons from '../../../../../assets/featureType'
import SidebarDetailHeader from '../../../SidebarDetailHeader'
import SidebarBody from '../../../SidebarBody'

function FeatureIconEditor(props) {
	const [activeTabIndex, setActiveTabIndex] = useState(0)
	const [searchOptions, setSearchOptions] = useState(props.searchOptions)
	const [searchQuery, setSearchQuery] = useState('')

	
	const handleClearResult = () => {
		setSearchOptions(props.searchOptions)
		setSearchQuery('')
	}

	const handleSearchChange = (e) => {
		const value = e.target.value
		setSearchQuery(value)
		const query = value.toLowerCase()
		const searchResults = []
		if (query !== '') {
			for (let searchableQuery in props.searchMap) {
				if (searchableQuery.indexOf(query) !== -1) {
					searchResults.push(...props.searchMap[searchableQuery])
				}
			}
		}
		setSearchOptions(searchResults)
	}

	const handleTabClick = (tabIndex) => {
		setActiveTabIndex(tabIndex)
	}

	const tabs = [
		{
			title: 'All (A-Z)',
			component: <AllIcons />,
		},
		{
			title: 'Favorites',
			component: <FavoriteIcons />,
		},
	]

	FeatureIconEditor.propTypes = {
		searchMap: PropTypes.object,
		searchOptions: PropTypes.array,
		selectedFeature: PropTypes.object,
		// actions
		searchingIcons: PropTypes.func,
		updateFeatureIcon: PropTypes.func,
	}

	return (
		<>
			<SidebarDetailHeader title='Select a Type' />
			<div className={styles.container}>
				<div className={styles.search}>
					<i className={styles.searchIcon}>
						<Search color='#888' width={18} />
					</i>
					<div className={styles.searchInput}>
						<input placeholder={'Search for type'} className={styles.searchInputValue} value={searchQuery} onChange={handleSearchChange} />
					</div>
					<i className={styles.clearIcon} onClick={handleClearResult}>
						<ClearCircle color='#888' width={18} />
					</i>
				</div>
			</div>
			{searchQuery ? (
				<div className={`${styles.options} ${searchQuery && styles.suggestedOptions}`}>
					{searchOptions.map((so, i) => {
						return <IconItem key={i} image={so.image} name={so.name} title={so.title} />
					})}
				</div>
			) : (
				<>
					<div className={styles.container}>
						<div className={styles.iconTabs}>
							{tabs.map((tab, i) => {
								return (
									<Chip key={i} size={Chip.SIZE.small} theme={i === activeTabIndex ? Chip.THEME.white : Chip.THEME.outlinePrimary} onClick={() => handleTabClick(i)} >
										{tab.title}
									</Chip>
								)
							})}
						</div>
					</div>
					<SidebarBody>{tabs[activeTabIndex].component}</SidebarBody>
				</>
			)}
		</>
	)
}

FeatureIconEditor.defaultProps = {}

export default connect((model) => {
	const { selectedFeature } = model.features
	const searchMap = {}
	const searchOptions = []
	for (let ili = 0; ili < ICON_LIST.length; ili++) {
		const { key, display } = ICON_LIST[ili]
		const searchableQuery = display.toLowerCase()
		const searchResult = {
			image: typeIcons[display.replace(/ /g, '')],
			name: key,
			title: display,
		}
		if (!searchMap[searchableQuery]) {
			searchMap[searchableQuery] = []
		}

		searchMap[searchableQuery].push(searchResult)
		searchOptions.push(searchResult)
	}
	return {
		searchMap,
		searchOptions,
		selectedFeature,
	}
}, actions)(FeatureIconEditor)
